import debounce from '../util/debounce';

let lastWindowWidth = window.innerWidth;
let lastWindowHeight = window.innerHeight;

function dispatch() {
  document.dispatchEvent(
    new CustomEvent('theme:resize', {
      bubbles: true,
    })
  );

  if (lastWindowWidth !== window.innerWidth) {
    document.dispatchEvent(
      new CustomEvent('theme:resize:width', {
        bubbles: true,
      })
    );

    lastWindowWidth = window.innerWidth;
  }

  if (lastWindowHeight !== window.innerHeight) {
    document.dispatchEvent(
      new CustomEvent('theme:resize:height', {
        bubbles: true,
      })
    );

    lastWindowHeight = window.innerHeight;
  }
}

function resizeListener() {
  window.addEventListener(
    'resize',
    debounce(function () {
      dispatch();
    }, 50)
  );
}

export default resizeListener;
